exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.LanguageOptions .language-options-container{padding:0;margin:0}.LanguageOptions .language-options-container .language-option{display:flex;justify-content:space-between;align-items:center;padding:18px 24px;border-bottom:1px solid #8b8b8b;height:50px;box-sizing:border-box}.LanguageOptions .language-options-container .language-option--first{padding:8px 24px 18px;height:40px}.LanguageOptions .language-options-container .language-option__text{font-family:Open Sans,sans-serif;font-size:16px;font-weight:600;color:#2c2c2c;margin:0}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/LanguageOptions/LanguageOptions.scss
// module id = 1575
// module chunks = 0